import useGetSalesRepTypeReport from '../hooks/useGetSalesRepTypeReport'
import {SalesRepTypeReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import SalesRepTypeReportTable from '../sections/table/SalesRepTypeTable'
import { SalesRepTypeReportsHeader } from '../sections/header/SalesRepTypeReportsHeader'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'

function SalesRepTypeReport() {
  const {
    reportData: salesRepTypeData,
    isLoading: isSalesRepTypeLoading,
    filters,
    onSortingChange,
    onDateChange,
  } = useGetSalesRepTypeReport()

  const {
    entityPerformanceChartData,
    isLoading:isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('sales_rep_type')

  const contextValue = {
    salesRepTypeData,
    isSalesRepTypeLoading,
    filters,
    onSortingChange,
    onDateChange,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  }

  return (
    <KTCard>
      <SalesRepTypeReportContext.Provider value={contextValue}>
        <SalesRepTypeReportsHeader />
        <SalesRepTypeReportTable />
      </SalesRepTypeReportContext.Provider>
    </KTCard>
  )
}

export default SalesRepTypeReport
